var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en

var dropdown = require('angular-ui-bootstrap/src/dropdown')

angular.module('inputComboboxCmp', [dropdown])
  .factory('visibilityDependencyDataservice', require('../../../../services/visibility-dependency.dataservice'))
  .component('inputCombobox', {
    template: require('./input-combobox.component.tpl.html'),
    controller: InputComboboxCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '=',
      resetVisibleFieldsValidity: '&'
    }
  })

InputComboboxCtrl.$inject = ['$timeout', 'visibilityDependencyDataservice', 'i18n']

function InputComboboxCtrl ($timeout, visibilityDependencyDataservice, i18n) {
  var vm = this
  vm.setOption = setOption

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
  }

  $timeout(function () {
    if (vm.formField.mandatory) {
      vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('required', false)
      if (vm.formField.defaultValueI18N) {
        vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('required', true)
      }
    }

    if (vm.formField.defaultValueI18N) {
      setOption(vm.formField.defaultValueI18N)
    }
  }, 0)

  function setOption (option) {
    vm.value[vm.formField.id] = option
    vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('required', !!Object.keys(vm.value).length)
    vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('invalidDefault', true)

    var visibleNow = visibilityDependencyDataservice.nodeValuesChanged(vm.formField.id, option)
    if (visibleNow.length) {
      vm.resetVisibleFieldsValidity()
    }
  }
}
